import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../Card';
import Button from '../Button';
import CreateModal from './CreateModal';

export default function CreateCard() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Card className="relative">
        {/* Plus Icon */}
        <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-black dark:bg-white flex items-center justify-center">
          <svg
            className="w-6 h-6 text-white dark:text-black"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>

        {/* Content */}
        <h2 className="text-2xl font-bold mb-2 dark:text-gray-100 pr-12">
          {t('dashboard.create.title')}
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {t('dashboard.create.description')}
        </p>

        {/* CTA Button */}
        <Button
          variant="primary"
          onClick={() => setIsModalOpen(true)}
          className="w-full sm:w-auto"
        >
          {t('dashboard.create.button')}
        </Button>
      </Card>

      {/* Create Modal */}
      <CreateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
